import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';

import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

class PaymentDailyEditModal extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_name_id: '',
      daily_currency: '',
      schedule_name_selected: 1,
      schedule_name: '',
      aircraft_model: '',
      staff: '',
      ignores_debts: 0,
      daily_value: 1,
      daily_paid: 1,
      payment_days: [],
      payment_editions: [],
      bonus: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.editPayment = this.editPayment.bind(this);
    this.addDay = this.addDay.bind(this);
    this.deleteDay = this.deleteDay.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }


  handleChangeDailyValue (event, name) {
    var change = {};
    change[name] = event;

    this.setState(change);
    this.handleChangeDailyTotal(event, this.state.daily_paid);
  }

  handleChangeDaily (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(event.target.value, this.state.daily_paid);
  }
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
  }

  handleChangeDailyTotal (daily_value, daily_paid) {
    var daily_paid = daily_paid;
    if (isNaN(daily_paid)) {
      daily_paid = 0;
    }
    var total = daily_paid * daily_value;

    this.setState({daily_total: total.toFixed(2)});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.data_payment_daily.id !== 'undefined') {
        this.setState({
          payment_editions: newProps.data_payment_daily.payment_editions,
          payment_days: newProps.data_payment_daily.payment_days,
          schedule_name: newProps.data_payment_daily.schedule_name,
          aircraft_model: newProps.data_payment_daily.aircraft_model,
          staff: newProps.data_payment_daily.staff,
          date_start: newProps.data_payment_daily.date_start_str,
          date_finish: newProps.data_payment_daily.date_finish_str,
          daily_value: newProps.data_payment_daily.daily_value,
          daily_paid: newProps.data_payment_daily.daily_paid,
          daily_total: newProps.data_payment_daily.daily_total,
          daily_currency: newProps.data_payment_daily.daily_currency,
          revision: newProps.data_payment_daily.revision,
          certification_supplier: newProps.data_payment_daily.certification_supplier,
          bonus: newProps.data_payment_daily.bonus,
          ignores_debts: newProps.data_payment_daily.ignores_debts,
          justification: newProps.data_payment_daily.justification,
          observation: newProps.data_payment_daily.observation,
          id: newProps.data_payment_daily.id,
        });
      }
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  // Fetch salvando a adição de diária
  deleteDay(id) {
    if (window.confirm(this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.deletarEsseDia)) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/dia/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({ payment_days: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando a diária
  addDay(event) {
    event.preventDefault();
    var datasave = {
      date: this.state.date,
      coefficient: this.state.coefficient,
      payment_id: this.state.id,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/dia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ payment_days: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  editPayment(event) {
    event.preventDefault();
    var datasave = {
      payment_type: 'daily',
      daily_value: this.state.daily_value,
      daily_paid: this.state.daily_paid,
      daily_total: this.state.daily_total,
      justification: this.state.justification,
      observation: this.state.observation,
      ignores_debts: this.state.ignores_debts,
      bonus: this.state.bonus,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({ modal: false });
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tituloEditarPagamento}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.editPayment}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.Escala}:</label>
                    <input value={this.state.schedule_name + ' - ' + this.state.aircraft_model} disabled="disabled" name="schedule_name" className="form-control" onChange={this.handleChange.bind(this, 'schedule_name')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.Revisao}:</label>
                    <input type="text" name="revision" className="form-control" placeholder="" value={this.state.revision} disabled="disabled" onChange={this.handleChange.bind(this, 'revision')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.Local}:</label>
                    <input value={this.state.certification_supplier} disabled="disabled" name="certification_supplier" className="form-control" onChange={this.handleChange.bind(this, 'certification_supplier')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.placeholder.Local} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.Tripulante}:</label>
                    <input value={this.state.staff} disabled="disabled" name="staff" className="form-control" onChange={this.handleChange.bind(this, 'staff')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.placeholder.Tripulante} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.DiariaValor}:</label>
                    <input value={this.state.daily_value} disabled="disabled" name="daily_value" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_value')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.DiariasPagas}:</label>
                    <input type="number" value={this.state.daily_paid} name="daily_paid" className="form-control" onChange={this.handleChangeDailyPaid.bind(this, 'daily_paid')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.DiariaMoeda}:</label>
                    <input value={this.state.daily_currency} disabled="disabled" name="daily_currency" className="form-control" onChange={this.handleChange.bind(this, 'daily_currency')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.placeholder.Moeda} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.DiariaTotal}l:</label>
                    <input value={this.state.daily_total} disabled="disabled" name="daily_total" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_total')} placeholder="" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.Observacao}:</label>
                    <input value={this.state.observation} name="observation" className="form-control" onChange={this.handleChange.bind(this, 'observation')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.placeholder.Observacao} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.IgnorarSaldoDevedor}?</label>
                    <br/>
                    <Toggle
                      defaultChecked={this.state.ignores_debts}
                      checked={this.state.ignores_debts}
                      aria-label='No label tag'
                      name="ignores_debts"
                      onChange={this.handleToggleChange.bind(this, 'ignores_debts')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.JustificativaDeEdicao}:</label>
                    <input value={this.state.justification} required name="justification" className="form-control" onChange={this.handleChange.bind(this, 'justification')} placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.placeholder.JustifiqueAEdicao} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioEditarPagamento.botaoSalvarPagamento}</button>
                </div>
              </div>
            </form>
            <hr/>
            <h3>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tituloAdicionarDia}</h3>
            <hr/>
            <form onSubmit={this.addDay}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioAdicionarDia.Data}:</label>
                    <InputMask value={this.state.date} maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioAdicionarDia.Coeficiente}:</label>
                    <input type="text" name="coefficient" className="form-control" placeholder="" value={this.state.coefficient} onChange={this.handleChange.bind(this, 'coefficient')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.formularioAdicionarDia.botaoSalvarDia}</button>
                </div>
              </div>
            </form>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaAdicionarDia.Dia}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaAdicionarDia.Coeficiente}</th>
                  <th className="text-center col-md-2">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaAdicionarDia.Acoes}</th>
                </tr>
              </thead>
              <tbody id="schedule_name-certification-staffs">
                {Object.keys(self.state.payment_days).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.payment_days[k].date_str}</td>
                      <td className="text-center">{self.state.payment_days[k].coefficient}</td>
                      <td className="text-center"><button className={'btn btn-danger'} onClick={() => self.deleteDay(self.state.payment_days[k].id)}><i className="fa fa-fw fa-trash"></i></button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <hr/>
            <h3>{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tituloLogDeEdicoesDoPagamento}</h3>
            <hr/>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.Id}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.QuantidadeAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.QuantidadeEditada}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.ValorUnitarioAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.ValorUnitarioEditado}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.ValorTotalAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.ValorTotalEditado}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.StatusDeSaldoDevedorAnterior}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.StatusDeSaldoDevedorEditado}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.UsuArio}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.Justificativa}</th>
                  <th className="text-center">{this.locale.PagamentosDeEscala.PagamentosEmAbertoDiariasDeMissao.tabelaLogDeEdicoesDoPagamento.Data}</th>
                </tr>
              </thead>
              <tbody id="schedule_name-certification-staffs">
                {Object.keys(self.state.payment_editions).map(function(k) {
                  return (
                    <tr>
                      <td className="text-center">{self.state.payment_editions[k].id}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_daily_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_daily_paid}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_daily_value}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_daily_value}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_daily_total}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_daily_total}</td>
                      <td className="text-center">{self.state.payment_editions[k].last_ignores_debts}</td>
                      <td className="text-center">{self.state.payment_editions[k].actual_ignores_debts}</td>
                      <td className="text-center">{self.state.payment_editions[k].user}</td>
                      <td className="text-center">{self.state.payment_editions[k].justification}</td>
                      <td className="text-center">{self.state.payment_editions[k].date_str}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default PaymentDailyEditModal;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentDailyEditModal.js